module.exports = __webpack_public_path__ + "img/9e9347f.png";